import {
  border,
  shadows,
  ShadowsSize,
} from 'src/components/foundations/tokens';
import styled from 'styled-components';

export const CardContainerStyled = styled.div<{
  hasShadow: boolean;
  $shadowSize: ShadowsSize;
  $width: string;
  $margin: string;
}>`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  border-radius: ${border.radius.lg}px;
  box-shadow: ${({ hasShadow, $shadowSize }) =>
    !hasShadow ? 'none' : `${shadows.sizes[$shadowSize]}`};
  width: ${({ $width }) => $width ?? '100%'};
  margin: ${({ $margin }) => $margin ?? '0'};
`;
